import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=07e9f16c&scoped=true&"
import script from "./Statistics.vue?vue&type=script&lang=js&"
export * from "./Statistics.vue?vue&type=script&lang=js&"
import style0 from "./Statistics.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Statistics.vue?vue&type=style&index=1&id=07e9f16c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e9f16c",
  null
  
)

export default component.exports